<div class="selection-container">
  <div class="title-date-container">
    <div class="title">
      {{ 'CRM.SCREEN.DAILY_OPERATING_PLANS' | translate }}
    </div>
    <app-shift-date-panel
      id="shift-date-sel"
      (dateChange)="onDateChange($event)"
      #shiftDateSel
    />
  </div>
  @if (!isLoading) {
    <div class="entry-type-buttons">
      @for (group of dopGroupButtons; track $index) {
        <button
          pButton
          label="{{ group.dopGroup.name }}"
          (click)="loadDOPGroupEntries(group)"
          [ngClass]="
            group.selected
              ? 'selected-button-background'
              : 'unselected-button-background'
          "
        ></button>
      }
    </div>
  }
</div>

@if (isLoading) {
  <p-progressSpinner class="center" />
}
@if (!isLoading) {
  <div class="dop-entries-container">
    @for (aor of aors; track $index) {
      <div class="aor-container">
        <div class="aor-title">{{ aor.name }}</div>
        <div class="sub-systems-container">
          <div class="sub-systems-item">
            <div class="sub-system-title">
              <div>{{ aor.name }}:</div>
              <button
                pButton
                label="{{ 'COMMON.LABEL.BUTTONS.ADD' | translate }}"
                class="dop-entry-add-button"
                icon="fa fa-fw fa-plus"
                (click)="addDopEntry(aor, null)"
                [disabled]="areEntriesReadOnly()"
              ></button>
            </div>
            <p-scrollPanel class="dop-entries-scroll-panel">
              @for (entry of getMatchingEntriesForAor(aor.id); track $index) {
                <app-log-entry
                  [entry]="entry"
                  [canEdit]="canEditEntry(entry)"
                  [canDelete]="canDeleteEntry(entry)"
                  (editEvent)="onEntryEdit(entry)"
                  (deleteEvent)="deleteEntry(entry)"
                />
              }
            </p-scrollPanel>
          </div>

          @for (subSystem of aor.aorSubSystems; track $index) {
            <div class="sub-systems-item">
              <div class="sub-system-title">
                <div>{{ subSystem.name }}:</div>
                <button
                  pButton
                  label="{{ 'COMMON.LABEL.BUTTONS.ADD' | translate }}"
                  class="dop-entry-add-button"
                  icon="fa fa-fw fa-plus"
                  (click)="addDopEntry(aor, subSystem)"
                  [disabled]="areEntriesReadOnly()"
                ></button>
              </div>
              <p-scrollPanel class="dop-entries-scroll-panel">
                @for (
                  entry of getMatchingEntriesForAorSubSystem(subSystem.id);
                  track $index
                ) {
                  <app-log-entry
                    [entry]="entry"
                    [canEdit]="canEditEntry(entry)"
                    [canDelete]="canDeleteEntry(entry)"
                    (editEvent)="onEntryEdit(entry)"
                    (deleteEvent)="deleteEntry(entry)"
                  />
                }
              </p-scrollPanel>
            </div>
          }
        </div>
      </div>
    }
  </div>
}

<app-dop-entry-form
  [showEntryDialog]="showEntryDialog"
  [selectedEntry]="selectedEntry"
  [aor]="selectedAor"
  [aorSubSystem]="selectedAorSubSystem"
  [shiftDate]="getShiftDateString(shiftDateSel.value)"
  (entryDialogHidden)="onEntryDialogHidden()"
  (entryChangedEvent)="onEntryChanged()"
  #dopForm
/>
